import { render, staticRenderFns } from "./box-indent.vue?vue&type=template&id=5e4892b4&scoped=true&"
import script from "./box-indent.vue?vue&type=script&lang=js&"
export * from "./box-indent.vue?vue&type=script&lang=js&"
import style0 from "./box-indent.vue?vue&type=style&index=0&id=5e4892b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4892b4",
  null
  
)

export default component.exports